import "../../styles/loader.css";

export const Loader = () => {
    return (
        <div className="blk-bg flx-col c-al c-jt">
            <div className="loader flx-rw c-al c-jt">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    )
}